/* ITT — Front Page Cube (clone only, Oct 30, 2026)
   Turns the headline cube: swipe/drag (pointer), >=48px prev/next,
   face chips, arrow keys on the stage. UI-REPAIR 2026-10-31: a static
   resting angle (REST_X/REST_Y) replaces the perfectly square 0deg
   pose so the cube reads as an object at rest; still no autoplay and
   no idle loop —
   the only continuous input is the theme's ONE ITTMotion tilt stream,
   applied as a small rotate bias (no new permission, no new sensor
   listener). Under prefers-reduced-motion the CSS kills the turn
   transition and ITTMotion never starts, so the cube is fully still
   until a control is used. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-cube-root]');
  for (var r = 0; r < roots.length; r++) init(roots[r]);

  function init(root) {
    var stage = root.querySelector('[data-cube-stage]');
    var cube = root.querySelector('[data-cube]');
    if (!stage || !cube) return;
    var faces = Array.prototype.slice.call(root.querySelectorAll('[data-cube-face]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-cube-go]'));
    var prev = root.querySelector('[data-cube-prev]');
    var next = root.querySelector('[data-cube-next]');
    var idx = 0;          // active face 0..3
    var rot = 0;          // cube rotateY, degrees, cumulative
    var biasX = 0, biasY = 0;
    var half = 0;
    /* UI-REPAIR 2026-10-31: the resting pose carries a real angle so the
       object reads as a cube at rest — front face + weather side face +
       the new top lid visible with perspective. rot/bias semantics are
       unchanged; REST is added on top of them in apply(). */
    var REST_X = -6.5, REST_Y = -19;
    var dragTiltX = 0;    // extra rotateX while dragging vertically

    function measure() { half = cube.offsetWidth / 2; }
    function apply() {
      cube.style.transform = 'translateZ(' + (-half) + 'px) rotateX(' + (REST_X + biasX + dragTiltX).toFixed(2) + 'deg) rotateY(' + (rot + REST_Y + biasY).toFixed(2) + 'deg)';
    }
    function settle() {
      chips.forEach(function (c, i) { c.setAttribute('aria-pressed', i === idx ? 'true' : 'false'); });
      faces.forEach(function (f, i) {
        var active = i === idx;
        f.setAttribute('aria-hidden', active ? 'false' : 'true');
        var focusables = f.querySelectorAll('a, button');
        for (var k = 0; k < focusables.length; k++) {
          if (active) focusables[k].removeAttribute('tabindex');
          else focusables[k].setAttribute('tabindex', '-1');
        }
      });
    }
    function targetFor(i) {
      var want = -i * 90;
      var diff = ((want - rot) % 360 + 540) % 360 - 180;
      return rot + diff;
    }
    function go(i) {
      idx = ((i % 4) + 4) % 4;
      rot = targetFor(idx);
      apply(); settle();
    }
    function step(d) { go(idx + d); }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    chips.forEach(function (c) {
      c.addEventListener('click', function () { go(parseInt(c.getAttribute('data-cube-go'), 10)); });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    });

    /* drag / swipe — vertical page scroll stays native (touch-action: pan-y) */
    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('a, button')) return;
      drag = { x: e.clientX, y: e.clientY, rot0: rot, moved: false };
      cube.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (Math.abs(dx) > 4) drag.moved = true;
      rot = drag.rot0 + dx * 0.32;
      dragTiltX = Math.max(-8, Math.min(8, -dy * 0.06));
      apply();
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      var wasDrag = drag.moved;
      drag = null;
      dragTiltX = 0;
      cube.classList.remove('is-dragging');
      if (wasDrag) go(Math.round(-rot / 90));
      else apply();
    });

    /* gyro: subscribe to the existing motion engine; bias only, eased by
       the cube's own CSS transition. Engine off => callback reports 0,0. */
    if (window.ITTMotion && typeof window.ITTMotion.onTilt === 'function') {
      var ticking = false;
      window.ITTMotion.onTilt(function (x, y) {
        biasY = Math.max(-1, Math.min(1, x || 0)) * 3.2;
        biasX = Math.max(-1, Math.min(1, y || 0)) * -2.0;
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () { ticking = false; if (!drag) apply(); });
        }
      });
    }

    window.addEventListener('resize', function () { measure(); apply(); });
    measure(); apply(); settle();
    window.__ittCube = function () {
      return { face: idx, rot: Math.round(rot), restX: REST_X, restY: REST_Y, biasX: +biasX.toFixed(2), biasY: +biasY.toFixed(2), transform: cube.style.transform };
    };
  }
})();
